import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ListRowHeadingValue } from '~/components/list-row';
import { MetaItem, SettingsBody, SettingsData, SettingsHead } from '~/components/settings';
import { formatDate } from '~/lib/datetime';
import { useLayout } from '../../context';

export const LayoutDetails = () => {
  const { t } = useTranslation();
  const layout = useLayout();
  return (
    <Box>
      <SettingsHead>{t('common.labels.details')}</SettingsHead>
      <SettingsBody>
        <SettingsData className="last no-space-between">
          <Box sx={{ display: 'flex' }}>
            <MetaItem className="first">
              <ListRowHeadingValue heading={t('common.labels.width')} value={layout.width} />
            </MetaItem>
            <MetaItem>
              <ListRowHeadingValue heading={t('common.labels.height')} value={layout.height} />
            </MetaItem>
            <MetaItem>
              <ListRowHeadingValue
                heading={t('common.labels.description')}
                value={layout.description}
              />
            </MetaItem>
            <MetaItem>
              <ListRowHeadingValue
                heading={t('common.labels.created')}
                value={formatDate(layout.createdAt)}
              />
            </MetaItem>
            <MetaItem className="last">
              <ListRowHeadingValue
                heading={t('pages.layouts.detail.labels.updated')}
                value={formatDate(layout.updatedAt)}
              />
            </MetaItem>
          </Box>
        </SettingsData>
      </SettingsBody>
    </Box>
  );
};
